///////////////////////////////////////////////////////////////////////////////////
//
// The WhatsApp invitation that carries the public booking link (תיאום פגישות):
// the wording the business saved in the booking settings (הגדרות → תיאום פגישות
// אונליין → "נוסח ההודעה שנשלחת עם הקישור"), or the standard one. Every "send the
// booking link" button goes through here, so the wording is set once and whoever
// sends the link doesn't retype it.
//
///////////////////////////////////////////////////////////////////////////////////

import axiosV2 from '../core/http/axios_api_v2';


const LINK_TOKEN = '{{קישור לזימון פגישה}}';


export default {


    linkToken: LINK_TOKEN,


    defaultText: 'היי! מוזמנים לקבוע איתנו פגישה בקלות דרך הקישור הבא:',


    //the message for `link`: the saved wording (or `fallback`, or the standard one), with the
    //link where it says {{קישור לזימון פגישה}} - otherwise on its own line at the end
    compose(text, link, fallback) {

        text = String(text || '').replace(/\s+$/, '') || fallback || this.defaultText;

        if (text.indexOf(LINK_TOKEN) > -1)
            return text.split(LINK_TOKEN).join(link);

        return text + '\n' + link;
    },


    //the saved wording ('' = none saved). Never rejects - without it the standard one is sent
    loadText() {

        return axiosV2.get('booking/settings')
            .then(response => (response.data && response.data.inviteMessage) || '')
            .catch(() => '');
    },


    //opens the global send-link modal (App.vue) with the invitation for `link`.
    //options: phone (prefilled recipient), crewMemberId (the crew calendar the link points at),
    //fallback (the wording when nothing was saved), text (the wording to use instead of the saved one)
    open(root, link, options) {

        options = options || {};

        let textPromise = options.text !== undefined ? Promise.resolve(options.text) : this.loadText();

        return textPromise.then(text => {

            root.$emit('openSendLinkViaWhatsappModal',
                this.compose(text, link, options.fallback),
                options.phone || null,
                { bookingBaseLink: link, crewMemberId: options.crewMemberId || null });
        });
    },
};
